/**
 * RFC 7807 ProblemDetails, as the API emits it.
 *
 * `code` is the machine-readable half and the only part safe to branch on; `detail` is
 * prose and may be reworded server-side at any time.
 */
export interface ProblemDetails {
  readonly type?: string;
  readonly title?: string;
  readonly status?: number;
  readonly detail?: string;
  readonly instance?: string;
  readonly code?: string;
  readonly traceId?: string;
  readonly errors?: Record<string, string[]>;
}

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly problem: ProblemDetails,
  ) {
    super(problem.detail ?? problem.title ?? `Request failed with status ${status}.`);
    this.name = 'ApiError';
  }

  /** Machine-readable failure code, when the API supplied one. */
  get code(): string | undefined {
    return this.problem.code;
  }

  /** Field-level validation messages, when this was a validation failure. */
  get fieldErrors(): Record<string, string[]> {
    return this.problem.errors ?? {};
  }

  get isUnauthorized(): boolean {
    return this.status === 401;
  }

  /** True when the site has not been seeded yet — see the 503 from /public/site. */
  get isUnavailable(): boolean {
    return this.status === 503;
  }
}
